/**
 * @generated SignedSource<<1844c3b34bad96a9277d480820444b16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReturnPolicy_item$data = {
  readonly returnPolicy: {
    readonly accept: boolean | null;
    readonly buyerCopy: {
      readonly customizableDetailReturnCopy: {
        readonly htmlCopy: string | null;
      } | null;
      readonly returnPolicySection: {
        readonly htmlCopy: string | null;
      } | null;
      readonly returnPolicySectionCtaCopy: {
        readonly htmlCopy: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PdpSharedDetailReturnPolicy_item";
};
export type PdpSharedDetailReturnPolicy_item$key = {
  readonly " $data"?: PdpSharedDetailReturnPolicy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReturnPolicy_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "kind": "LinkedField",
      "name": "returnPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accept",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "kind": "LinkedField",
          "name": "buyerCopy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "userCountryCode",
                  "variableName": "userCountryCode"
                }
              ],
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "returnPolicySection",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "returnPolicySectionCtaCopy",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "customizableDetailReturnCopy",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "3655038d08e00ac832f9e6219e788186";

export default node;
